module.exports = __webpack_public_path__ + "img/4.72434238.jpg";